import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { PortalLogo } from '../images';

const weavePortalLogoPictureStyle1 = css`
  margin: ${theme.spacing(2)} auto;
  position: relative;
  display: inline-block;
  &::after {
    content: var(--weave-portal-logo-picture-inline-expr1);
    color: ${theme.colors.primary50};
    font-weight: bold;
    font-size: ${theme.fontSize(12)};
    position: absolute;
    bottom: 0;
    right: 0;
  }
`;

interface Props {
  subText?: string;
}

export const WeavePortalLogo = ({ subText = 'Portal' }: Props) => {
  return (
    <picture
      className={weavePortalLogoPictureStyle1}
      style={
        {
          '--weave-portal-logo-picture-inline-expr1': `"${subText.toUpperCase()}"`,
        } as any
      }
    >
      <PortalLogo title={`weave ${subText.toLowerCase()} logo`} />
    </picture>
  );
};
